/**
 * Define JSON
 * @typedef {string} JSON
 */

/**
 * JSON parsing function to handle invalid JSONs.
 *
 * @param {JSON} maybeJson
 * @param {boolean} [returnEmptyString=false]
 * @returns {(JSON|false|'')}
 */
const jsonParse = (maybeJson, returnEmptyString = false) => {
    let jsonObj;

    try {
        jsonObj = JSON.parse(maybeJson);
    } catch (error) {
        return returnEmptyString ? '' : false;
    }

    return jsonObj;
};

export default jsonParse;
